import type {
  AnnounceLevel,
  PublicAnnouncement,
} from "@/features/announce/api/announceClient";
import { cn } from "@/shared/lib/cn";
import { formatDate } from "@/shared/lib/date";

const LEVEL_LABEL: Record<AnnounceLevel, string> = {
  emergency: "緊急",
  important: "重要",
  normal: "通常",
};

const LEVEL_CLASS: Record<AnnounceLevel, string> = {
  emergency: "border-destructive bg-destructive/10",
  important: "border-primary bg-primary/10",
  normal: "border-border bg-muted",
};

interface AnnouncementLevelBadgeProps {
  level: AnnounceLevel;
}

export const AnnouncementLevelBadge: React.FunctionComponent<
  AnnouncementLevelBadgeProps
> = ({ level }: AnnouncementLevelBadgeProps) => {
  return (
    <strong
      className={cn(
        "inline-flex rounded border px-2 py-1 text-xs font-bold text-foreground",
        LEVEL_CLASS[level],
      )}
    >
      {LEVEL_LABEL[level]}
    </strong>
  );
};

interface AnnouncementTimestampsProps {
  announcement: Pick<PublicAnnouncement, "published_at" | "updated_at">;
  className?: string;
}

export const AnnouncementTimestamps: React.FunctionComponent<
  AnnouncementTimestampsProps
> = ({ announcement, className }: AnnouncementTimestampsProps) => {
  return (
    <dl
      className={cn(
        "flex flex-wrap gap-x-4 gap-y-1 text-sm text-muted-foreground",
        className,
      )}
    >
      {announcement.published_at && (
        <div className="flex gap-1">
          <dt>公開</dt>
          <dd>
            <time dateTime={announcement.published_at}>
              {formatDate(announcement.published_at)}
            </time>
          </dd>
        </div>
      )}
      <div className="flex gap-1">
        <dt>更新</dt>
        <dd>
          <time dateTime={announcement.updated_at}>
            {formatDate(announcement.updated_at)}
          </time>
        </dd>
      </div>
    </dl>
  );
};
